// Where today's documents went. Today's app kept plans and documents together
// and linked both as `/doc/<id>`; the new app keeps plans only (docs/architecture/
// plans-and-docs.md), so a document's link shows the repository path it moved to.
//
// The map is docs/board/ids.json, copied here so the bundle needs no file
// outside web/; that export is done once, at the switch.

/** A document's id in today's app, lower case, and the repository path it moved to. */
export type MovedDocuments = Readonly<Record<string, string>>

export const MOVED_DOCUMENTS: MovedDocuments = {
  '0256470c-3577-452d-8e42-ddfc70b7c2a1': 'docs/board/poulpe-the-stabilisation-night.md',
  '0554619e-c035-4e8f-a701-204ef250b456': 'docs/board/p0-the-freeze-of-sunplug-board-copy.md',
  '09943c96-0f1a-442e-a05a-2ea621acca03': 'docs/board/multi-tasking-optimization-evidence-and-proposal.md',
  '0c8ad9cf-0354-4727-8c22-16d0cf55c14e': 'docs/board/poulpe-end-state-and-architecture.md',
  '20043b5b-07f8-4bb7-a250-8014ed88e4de': 'docs/board/command-runner-design.md',
  '41b95f42-f574-4871-91d7-ae2c1a4b7aed': 'docs/board/poulpe-073-first-real-landing.md',
  '438826ea-c773-41b7-8ba1-0bf5823bf41a': 'docs/board/the-phone-app-first-scope.md',
  '5045a959-7baa-4e9c-924e-9dc0f2dd6c0d': 'docs/board/sunplug-side-work-for-the-switch.md',
  '5197e701-d459-498c-aaa7-11580314e50b': 'docs/board/p0-two-installs-side-by-side.md',
  '54957fbc-8052-4b2a-8b21-856d00ae02e3': 'docs/board/poulpe-102-agy-1-3-2-probe-and-initialization-blocker.md',
  '5f314cb2-6e42-4a89-a628-e40bb2a006eb': 'docs/board/p1-the-one-person-protocol-v1.md',
  '6519976d-6bf2-4dee-bcff-0805437bb3b8': 'docs/board/one-rust-core-for-every-poulpe-device.md',
  '7099b193-7283-4f14-b22e-8c365a062636': 'docs/board/brief-codex-lane-in-poulpe-next.md',
  '740c77ca-bf08-44b9-abda-9f904cfe26a6': 'docs/board/new-poulpe-offline-local-store-outbox-merge.md',
  '7623d662-29dc-461b-b2be-b2aeeb34d407': 'docs/board/p0-the-configuration-model.md',
  '77dd0cc1-99b0-4083-97b0-6808c9c25ed2': 'docs/board/app-0-1-2-release-notes.md',
  '7b61666a-47c7-42ca-8a11-507f98b2ac6a': 'docs/board/p0-poulpe-design-assembled.md',
  '80b41426-5cf8-4b99-9c86-d821e953a5fb': 'docs/board/multi-tasking-optimization-restart-handoff.md',
  '98dfc25a-d090-4193-a322-f4ce0f2a2098': 'docs/board/poulpe-073-propose-failure-diagnosis-and-repair.md',
  '994722b4-d557-4c2a-9588-81e23ad5f130': 'docs/board/p0-encryption-with-keys-the-users-own.md',
  '9fec8fc8-c9f8-4da2-b347-0f89af0e7f3f': 'docs/board/p0-the-configuration-model-appendix.md',
  'b5957f1e-8d31-4eae-b8f1-4278bc2f5777': 'docs/board/p0-how-poulpe-is-built-before-it-hosts-itself.md',
  'bf04b4c7-7be0-4f5a-a36b-ed0c07915014': 'docs/board/p0-the-copy-list.md',
  'c3f622a8-1019-4f02-b6d6-88bc6923d56a': 'docs/board/p0-what-the-board-assumes-of-sunplug.md',
  'c76a3bd3-29bb-461e-8d75-751dc23104d2': 'docs/board/the-way-back-from-the-switch-checklist.md',
  'c90d60c9-d8b2-4b1b-a375-3a2f0225ac4a': 'docs/board/p4-pull-requests-flow-approval-and-merge.md',
  'caa46344-e03d-4c04-935b-b9fcc4856833': 'docs/board/p0-sunplug-switch-export-import-cut-over.md',
  'd8730d34-5ef7-4e97-b252-a01fac3135f5': 'docs/board/poulpe-stabilisation-bugs-and-essential-tasks.md',
  'dc17297b-088c-4228-a8fb-1d4aa4a6cefe': 'docs/board/multi-tasking-optimization-live-copy-review.md',
  'e74192ca-8b10-4bd2-b361-e54f5f01efed': 'docs/board/poulpe-closing-the-stabilisation.md',
  'f444f953-ac8c-4883-992a-f1a1e3ff6809': 'docs/board/p0-the-hosted-service.md',
  'f4d0e538-ca9c-40f6-9b7c-e8548248e1b9': 'docs/board/p0-where-the-server-runs.md',
  'f6d80f42-b6ba-4e64-a9af-bf2eb19b2d24': 'docs/board/phone-companion-engine-choice-and-apple-prerequisites.md',
  'fee21251-56c5-4d3b-a23d-d8eca32f176c': 'docs/board/p0-poulpe-own-repository.md',
}

/**
 * Which repository a moved link names: today's filed documents went to the new
 * one (`docs/board/`); today's Docs tab read today's own repository's files.
 */
export type Repository = 'next' | 'today'

/** The repositories on GitHub. */
export const REPOSITORY_BLOB: Readonly<Record<Repository, string>> = {
  next: 'https://github.com/sunplug/poulpe/blob/main',
  today: 'https://github.com/sunplug/poulpe-legacy/blob/main',
}

/** A path in `repository` on GitHub, each part encoded. */
export function repositoryUrl(path: string, repository: Repository = 'next'): string {
  const blob = REPOSITORY_BLOB[repository]
  const parts = path.split('/').filter(Boolean).map(encodeURIComponent)
  return parts.length ? `${blob}/${parts.join('/')}` : blob
}
